import {
  Component
} from '@angular/core';

import {
  ReactiveFormsModule, FormsModule
} from '@angular/forms';

import { CommonModule }
from '@angular/common';

import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BaseFieldRenderer } from '../../../core/runtime/base/base-field-renderer';

@Component({
  selector: 'app-textarea-renderer',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MatFormField, MatFormFieldModule, MatInputModule],
  templateUrl:
    './textarea-renderer.component.html'
})
export class TextareaRendererComponent
extends BaseFieldRenderer {
}